import { useEffect, useState } from "react";
import { getSettingsStatus } from "@/lib/api";
import { createCachedFlagLoader } from "@/lib/providerFeatures";

const loadHeygenCreation = createCachedFlagLoader(getSettingsStatus);

// `enabled` is false until the server explicitly confirms HeyGen creation, and
// stays false if the status request fails.
export function useHeygenCreation() {
  const [state, setState] = useState({ loaded: false, enabled: false });
  useEffect(() => {
    let cancelled = false;
    loadHeygenCreation().then((enabled) => { if (!cancelled) setState({ loaded: true, enabled }); });
    return () => { cancelled = true; };
  }, []);
  return state;
}
